module.exports = __webpack_public_path__ + "static/aboutus-banner-6a59f52dbcaa83a7ed5c84aada0d5c2a.png";